<template>
    <v-container>
        <v-card color="rgb(37, 150, 190)">
            <v-card-title>Configurar</v-card-title>
            <v-form>
                <v-row justify="center">
                    <v-col cols="6">
                        <v-text-field 
                            hint="Número"
                            label="Número de chofer"
                            v-model="numeroChofer">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="6">
                        <v-btn @click="actualizarDatosChofer()" block color="green">Registrar</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>

import choferes from "../store/choferes"
import store from "../store"
import router from "@/router"

export default {
    name: "Configurar",

    data() {
        return {
            numeroChofer: '',
        }
    },

    methods: {
        clickEnRegistrar() {
            this.actualizarDatosChofer()
        },
        actualizarDatosChofer() {
            if (this.numeroChofer!="") {
                choferes.actions.getByNumero(this.numeroChofer)
                    .then(respuesta => {
                        store.dispatch("choferes/actualizar", {loggeado: true, numero: this.numeroChofer, nombre: respuesta.Nombre})
                        router.replace("/VerRutaActual")
                    })
                    .catch(puteada => {
                        store.dispatch("snackbar/mostrar", puteada)
                    })
            } else {
                store.dispatch("snackbar/mostrar", "Debe ingresar el número de chofer")
            }
        }
    },

}

</script>